import script from "./StatusSummaryBottomView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatusSummaryBottomView.vue?vue&type=script&setup=true&lang=ts"

import "./StatusSummaryBottomView.vue?vue&type=style&index=0&id=f190f6c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f190f6c8"]])

export default __exports__